import { Editor, generateJSON } from '@tiptap/react';
import { getEmojiNative } from 'src/modules/emoji/utils/getEmojiNative';
import { getExternalStore } from '../private/utils/getExternalStores';
import { MentionNode, Node } from './Renderer/types';

export const editorContentToPlaintext = (
  editor: Editor,
  content: string,
): string => {
  const def = generateJSON(content, editor.options.extensions);
  return parseContentToPlainText(editor, def);
};

export const parseContentToPlainText = (editor: Editor, node: Node): string => {
  if (!node) {
    return '';
  }

  if ('text' in node) {
    return node.text?.trim() ?? '';
  }

  if (node.type === 'mention') {
    const mention = node as MentionNode;
    const workspaceInfo = getExternalStore(editor, 'workspaceStore');
    const user = workspaceInfo?.getState().usersById[mention.attrs.id];
    return user?.name || mention.attrs.label || '@mention';
  }

  if (node.type === 'emoji-search') {
    return getEmojiNative((node as any).attrs.id) || '';
  }

  if ('content' in node && node.content)
    return (
      node.content?.map((i) => parseContentToPlainText(editor, i)).join(' ') ??
      ''
    );
  return '';
};
